import React from 'react';
import { useTranslation } from 'react-i18next';
import { IoImage as ImageIcon, IoRefresh as RotateCcw, IoDownload as Download } from 'react-icons/io5';

export default function ImagePreview({
  activeTool,
  processedImage,
  selectedImage,
  isProcessing,
  gridSettings,
  clearImage,
  downloadImage
}) {
  const { t } = useTranslation();
  return (
    <div className="bg-white rounded-2xl shadow-sm hover:shadow-md transition-all duration-500 overflow-hidden border border-gray-100">
      <div className="p-4 border-b bg-gray-50 flex justify-between items-center">
        <h3 className="font-semibold text-gray-800 flex items-center gap-2">
          <ImageIcon size={18} />
          {activeTool === 'grid' ? t('preview.title.grid') : t('preview.title.image')}
        </h3>
        {processedImage && (
          <span className="text-xs px-2 py-1 bg-green-100 text-green-800 rounded-full flex items-center gap-1">
            <div className="w-2 h-2 bg-green-600 rounded-full"></div>
            {t('preview.downloadable')}
          </span>
        )}
      </div>

      <div className="relative flex items-center justify-center min-h-[320px] p-6 bg-gray-50">
        {(!selectedImage && activeTool !== 'grid') ||
        (activeTool === 'grid' && gridSettings.images.length === 0 && !processedImage) ? (
          <div className="text-gray-400 text-center p-8 animate-pulse">
            <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <ImageIcon size={32} className="text-gray-300" />
            </div>
            <p className="text-gray-500">{t('preview.empty')}</p>
          </div>
        ) : (
          <div className="p-4 max-w-full max-h-[500px] overflow-auto">
            <div className="relative">
              <img
                src={processedImage || selectedImage}
                alt={activeTool === 'grid' ? t('preview.title.grid') : t('preview.title.image')}
                className="max-w-full max-h-[400px] object-contain rounded-lg shadow-sm transition-all duration-500 transform hover:scale-[1.02]"
              />
              {isProcessing && (
                <div className="absolute inset-0 bg-white bg-opacity-70 flex items-center justify-center rounded-lg">
                  <div className="w-10 h-10 border-4 border-blue-200 border-t-blue-600 rounded-full animate-spin"></div>
                </div>
              )}
            </div>
          </div>
        )}
      </div>

      {(selectedImage || (activeTool === 'grid' && (gridSettings.images.length > 0 || processedImage))) && (
        <div className="p-4 border-t bg-gray-50">
          <div className="flex gap-3">
            <button
              onClick={clearImage}
              className="flex-1 bg-gray-100 text-gray-700 py-2.5 rounded-lg hover:bg-gray-200 transition-all duration-300 flex items-center justify-center gap-2 focus:outline-none focus:ring-2 focus:ring-gray-300"
            >
              <RotateCcw size={18} />
              <span>{t('preview.clear')}</span>
            </button>

            <button
              onClick={downloadImage}
              disabled={!processedImage || isProcessing}
              className={`flex-1 py-2.5 rounded-lg transition-all duration-300 flex items-center justify-center gap-2 font-medium ${
                !processedImage || isProcessing ? 'bg-gray-300 text-gray-500 cursor-not-allowed' : 'bg-blue-600 text-white hover:bg-blue-700 shadow hover:shadow-md'
              }`}
            >
              <Download size={18} />
              <span>{t('preview.download')}</span>
            </button>
          </div>
        </div>
      )}
    </div>
  );
}